import {createSvgIcon} from '../create-svg-icon';

export const ManIcon = createSvgIcon(
  [<path d="M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2z" key="0" />,<circle cx="12" cy="4" r="2" key="1" />,]
, 'ManOutlined');
